export enum ImpactLensType {
  INSIGHTS = 'insights',
  TARGETS = 'targets',
  UPRIGHT_NET_IMPACT = 'upright-net-impact',
  SDGS = 'sdgs',
  EU_TAXONOMY = 'eu-taxonomy',
  EU_PAIS = 'eu-pais',
  CSRD = 'materiality', // TODO: Get rid of this once the company group DMA view has been migrated to proper path routing
  FINANCIAL_EFFECTS = 'financial-effects',
  CLIMATE_RISK = 'climate-risk',
}
